import React from "react"
import { Link, graphql, useStaticQuery } from "gatsby"
import { GatsbyImage, getImage, StaticImage } from "gatsby-plugin-image"
import { readingTime as readingTimeHelper } from "@tryghost/helpers"

function AuthorAvatar({ data }) {
  const siteSettings = useStaticQuery(graphql`
    query {
      site {
        siteMetadata {
          slugs {
            blog
            author
            tag
          }
        }
      }
    }
  `)
  const { slugs } = siteSettings.site.siteMetadata
  const { profileImage, published_at_pretty } = data
  const allAuthors = data.authors
  const readingTime = readingTimeHelper(data)
  const authorUrl = `${slugs.blog}${slugs.author}/`

  const authorsLinkStyles = index => {
    return allAuthors.length > 1
      ? `flex-shrink-0 mr-4 bg-gray-900 ${
          index === 0
            ? "border-4 border-gray-900 rounded-full z-[1] -ml-1 w-12"
            : index === 1
              ? "-ml-7 w-10"
              : ""
        }`
      : `flex-shrink-0 mr-4 w-10`
  }

  return (
    <>
      {allAuthors.map((author, index) => (
        <Link
          to={authorUrl + author.slug}
          className={`${authorsLinkStyles(index)}`}
          key={author.slug}
        >
          {profileImage[index] ? (
            <GatsbyImage
              image={getImage(profileImage[index])}
              imgClassName="rounded-full"
              alt={author.name}
            />
          ) : (
            <StaticImage
              quality={80}
              src="../images/film/unknown-person.jpg"
              imgClassName="rounded-full"
              width={40}
              height={40}
              alt={author.name}
            />
          )}
        </Link>
      ))}

      <div className="font-medium">
        {allAuthors.map((author, index) => (
          <React.Fragment key={author.slug}>
            {index > 0 && ", "}
            <Link
              to={authorUrl + author.slug}
              className="font-medium text-gray-300 hover:text-gray-100 transition duration-150 ease-in-out"
            >
              {author.name}
            </Link>
          </React.Fragment>
        ))}

        <div className="text-gray-500">
          {published_at_pretty} <span className="text-gray-600"> - </span>
          {readingTime}
        </div>
      </div>
    </>
  )
}

export default AuthorAvatar
